// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { getVideoCreatorListFailed, getVideoCreatorListRequested, getVideoCreatorListSucceeded } from './select-video-creator.actions';
import { VideoCreatorListResponse } from '@par/app/core/model/dictionaries.response';

export const STATE_NAME_SELECT_VIDEO_CREATOR = 'select-video-creator';

export interface State {
  response?: VideoCreatorListResponse;
  responseError: boolean;
  responseLoading: boolean;
}

const initialState: State = {
  response: undefined,
  responseError: false,
  responseLoading: false,
};

const reducer = createReducer(
  initialState,
  on(getVideoCreatorListRequested, (state) => (
    state.response != null
      ? state
      : {...state, responseLoading: true, responseError: false}
  )),
  on(getVideoCreatorListSucceeded, (state, {response}) => ({...state, responseLoading: false, response, responseError: false})),
  on(getVideoCreatorListFailed, (state) => ({...state, responseLoading: false, responseError: true})),
);

export function selectVideoCreatorReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

